import React, { useCallback, useMemo } from 'react';
import { prop } from 'ramda';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentConfig } from 'js/hooks/component';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useDynamicReducerSelector } from '../store';

import style from '../LoginHistory.scss';

export const useTableData = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const history = useDynamicReducerSelector(prop('history'));
    const { showLoginTable } = useComponentConfig();
    const getAccordionCell = useCallback((name: string, value: string) => {
        return (
            <>
                <div className="accordionBodyCellName">{translate(name)}</div>
                <div className="accordionBodyCellValue">{value}</div>
            </>);
    }, [translate]);

    const data = useMemo(() =>
        history.map(({
            clientType,
            clientPlatform,
            loginDate,
            logoutDate,
            ipAddress
        }) => ({
            id: loginDate,
            loginDate: formatter.getDateTimeShort(formatter.parseImsDate(loginDate)),
            logoutDate: logoutDate && formatter.getDateTimeShort(formatter.parseImsDate(logoutDate)) || '',
            clientPlatform,
            clientType,
            ipAddress
        })), [history, formatter]);

    return useMemo(() =>
        showLoginTable
        ? {
            tableView: {
                headerCells: [
                    { id: 0, content: translate('table.loginDate') },
                    { id: 1, content: translate('table.logoutDate') },
                    { id: 2, content: translate('table.clientPlatform') },
                    { id: 3, content: translate('table.clientType') },
                    { id: 4, content: translate('table.IP'), className: style.ip }
                ],
                rows: data.map((item) => {
                    return {
                        id: item.id,
                        rowCells: [
                            { id: 0, content: item.loginDate },
                            { id: 1, content: item.logoutDate },
                            { id: 2, content: item.clientPlatform },
                            { id: 3, content: item.clientType },
                            { id: 4, content: item.ipAddress, className: style.ip }
                        ]
                    };
                })
            },
            accordionView: {
                rows: data.map((item) => {
                    const { clientType, clientPlatform, loginDate, logoutDate, ipAddress, id } = item;
                    const rowCells = [];

                    logoutDate && rowCells.push({ id: 1, content: getAccordionCell('table.logoutDate', logoutDate) });
                    clientPlatform && rowCells.push({ id: 2, content: getAccordionCell('table.clientPlatform', clientPlatform) });
                    clientType && rowCells.push({ id: 3, content: getAccordionCell('table.clientType', clientType) });
                    ipAddress && rowCells.push({ id: 4, content: getAccordionCell('table.IP', ipAddress) });

                        return {
                            id,
                            rowCells,
                            headerCells: [
                                {
                                    id: 0,
                                    className: `${style.headerCell}`,
                                    content: translate('table.headerCell')
                                },
                                {
                                    id: 1,
                                    className: `${style.headerValueCell} accordionHeaderSmallDetails`,
                                    content: loginDate
                                }
                            ]
                        };
                    }),
                tableViewHeaderCells: []
            }
        }
        : { tableView: { rows: [] }, accordionView: { rows: [] } }
    , [data, translate, getAccordionCell, showLoginTable]);
};
